var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-message-container"},[_c('BaseIcon',{attrs:{"icon":"info-circle"}}),_c('BaseParagraph',[_vm._v(" "+_vm._s(_vm.$t('chat_system_message_room_updated', { fullName: _vm.name }))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }